import { MiddlewareGuard } from '../guards/middleware.guard';
import { StateableGuard } from '../guards/stateable-guard.guard';

import { MostrarComponent as DashboardMostrarComponent } from '../modules/dashboard/pages/mostrar/mostrar.component';
import { Route } from '@angular/router';
export const ROUTES_DASBOARD: Route[] = [
  { path: '', component: DashboardMostrarComponent },
  {
    path: 'grupo/:grupo_id/mostrar',
    loadChildren: () => import('../modules/grupo/grupo-dashboard.module').then(module => module.GrupoDashboardModule),
    canActivate: [MiddlewareGuard, StateableGuard],
  },
  {
    path: 'grupo/:grupo_id/empresa/:empresa_id',
    canActivate: [MiddlewareGuard, StateableGuard],
    loadChildren: () => import('../modules/empresa/empresa-dashboard.module').then(module => module.EmpresaDashboardModule),
  },
  {
    path: 'grupo/:grupo_id/empresa/:empresa_id/sucursal/:sucursal_id',
    loadChildren: () => import('../modules/sucursal/sucursal-dashboard.module').then(module => module.SucursalDashboardModule),
    canActivate: [MiddlewareGuard],
  },
];
